import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../rootState';
import { selectCurrentLanguage } from '../modules/language';
import { LanguageEntries } from '../shared/language/LanguageEntries';
import { availableLanguages } from '../shared/language/Language';

interface StateProps {
  language: ReturnType<typeof selectCurrentLanguage>;
}

type TranslateCallback = (key: keyof LanguageEntries) => string;

interface OwnProps {
  children?: (translate: TranslateCallback) => React.ReactNode;
}

type Props = StateProps & OwnProps;

class Translator extends React.Component<Props> {
  public render() {
    const { children } = this.props;
    if (children == null) {
      return null;
    }
    return <>{children(this.translate)}</>;
  }

  private translate: TranslateCallback = key => {
    const { language } = this.props;
    const context = availableLanguages[language];

    if (context != null) {
      const translation = context.translate(key);
      if (translation != null) {
        return translation;
      }
    }

    return `[${key}]`;
  };
}

const mapStateToProps = (state: RootState) => ({
  language: selectCurrentLanguage(state),
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Translator);



// WEBPACK FOOTER //
// ./src/components/Translator.tsx